import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackProductFeedClick } from '@app/+catalog/store';

/**
 * When the user clicks on a product in the cross-sell module on the product page.
 */
const events = getEvents((action: TrackProductFeedClick) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'clickProductFeed',
      blockSubCategory: action.payload.blockSubCategory,
      position: action.payload.position,
      index_name: action.payload.indexName,
      product_id: action.payload.productId,
      page_type: action.payload.page_type
    }
  }
]);

export default events;
